import React from "react";
import { GregPrimerTheme } from "@getregistered/greg-editors";
import { ToastManager } from "./ToastManager";

export const ToastManagerRoot: React.FC = () => {
  return (
    <GregPrimerTheme>
      <ToastManager />
    </GregPrimerTheme>
  );
};

